import React, { useEffect, useRef, useState } from 'react';
import { GRADIENTS, COLORS } from './themeConstants';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';

const AboutUs = () => {
	const [isVisible, setIsVisible] = useState(false);
	const sectionRef = useRef(null);
	const history = useHistory();

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setIsVisible(entry.isIntersecting);
			},
			{ threshold: 0.3 }, // Adjusted threshold for better trigger
		);

		if (sectionRef.current) {
			observer.observe(sectionRef.current);
		}

		return () => {
			if (sectionRef.current) {
				observer.unobserve(sectionRef.current);
			}
		};
	}, []);

	return (
		<section ref={sectionRef} id='about-us' className={`min-h-screen w-full py-16 bg-gradient-to-br ${GRADIENTS.background.primary} ${COLORS.text.primary} overflow-hidden`}>
			<div className='container mx-auto px-4'>
				<div className={`transform transition-transform duration-900 ease-out mb-16 text-center ${COLORS.text.primary} ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`}>
					<h1 className={`text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>About Necttos</h1>
					<p className={`text-lg md:text-xl ${COLORS.text.secondary} max-w-3xl mx-auto leading-relaxed px-4 sm:px-0`}>Necttos is evolving from an OPC Private Limited to a Public Limited company, marking a transformative shift in education management. Our mission is to ease administrative burdens on teachers, empowering them to concentrate on research and teaching, while our innovative solutions streamline college operations for enhanced efficiency and accessibility.</p>
				</div>

				<div className={`mb-16 p-8 rounded-2xl backdrop-blur-lg ${COLORS.background.glass} border ${COLORS.border.glass} hover:scale-105 transform transition-transform duration-700 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
					<h2 className={`text-3xl md:text-4xl font-bold mb-6 text-center bg-gradient-to-r ${GRADIENTS.text.primary} bg-clip-text text-transparent`}>Why Choose Us?</h2>
					<p className={`text-md md:text-lg ${COLORS.text.secondary} leading-relaxed text-center max-w-4xl mx-auto px-4 sm:px-0`}>Discover a new way to manage education with Necttos. Our company is led by a full stack developer skilled in accounts and academics. His quick learning and problem-solving skills are our strength. We are changing into a Public Limited Company, and our team of 10 dedicated administrators will help us reach our vision. In the next 365 days, we plan to open 14 offices in 14 districts and hire 56 new MERN stack developers to support colleges onsite and online. As a software company, we constantly update our programs and add new features to meet academic needs. Since 2021, the colleges using Necttos have switched to the FYUGP module without delays or extra cost. Invest in Necttos and help build a smarter, more connected future for education.</p>
				</div>

				<div className='grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto'>
					<div className={`p-8 rounded-2xl backdrop-blur-lg ${COLORS.background.glass} border ${COLORS.border.glass} hover:scale-105 transform transition-transform duration-700 ease-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'} overflow-hidden`}>
						<h3 className={`text-2xl md:text-3xl font-bold mb-4 bg-gradient-to-r ${GRADIENTS.text.secondary} bg-clip-text text-transparent`}>Our Mission</h3>
						<p className={`${COLORS.text.secondary} leading-relaxed`}>To empower communities by leveraging innovative technology to enhance education, foster collaboration, and provide seamless access to knowledge and opportunities.</p>
					</div>

					<div className={`p-8 rounded-2xl backdrop-blur-lg ${COLORS.background.glass} border ${COLORS.border.glass} hover:scale-105 transform transition-transform duration-700 ease-out ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'} overflow-hidden`}>
						<h3 className={`text-2xl md:text-3xl font-bold mb-4 bg-gradient-to-r ${GRADIENTS.text.secondary} bg-clip-text text-transparent`}>Our Vision</h3>
						<p className={`${COLORS.text.secondary} leading-relaxed`}>Connecting communities through innovative technology for a better future in education and collaboration.</p>
					</div>
				</div>

				<footer className='mt-16 text-center'>
					<button onClick={() => history.push('/register')} className={`mt-4 px-6 py-3 bg-gradient-to-r ${GRADIENTS.button.primary} text-white font-semibold rounded-lg hover:opacity-80 transition-opacity hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400`}>
						Join Us Now
					</button>
				</footer>
			</div>
		</section>
	);
};

export default AboutUs;
